// extracted by mini-css-extract-plugin
export default {"App":"App_App__fvQ1t","requestMassage":"App_requestMassage__oJs+b","errorMassage":"App_errorMassage__o4Til","spinier":"App_spinier__2QsJU"};